import React from 'react';
import { useAuth } from 'hooks/useAuth/authContext';

const UserContext = React.createContext();

export function UserProvider({ children }) {
  const {
    state: { user, userLoading, loading },
    getUser,
    refreshUser,
    logoutUnAuthorised,
  } = useAuth();

  const value = React.useMemo(
    () => ({
      user,
      userLoading,
      loading,
      getUser,
      refreshUser,
      logoutUnAuthorised,
    }),
    [user, userLoading, loading, getUser, refreshUser, logoutUnAuthorised],
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export default function useUser() {
  const context = React.useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }
  return context;
}
